export default { sha: '1309a0698aeef301554d87e33adaefc922f5f72b', buildNumber: 'undefined' }
